// extracted by mini-css-extract-plugin
export var productImage = "_or-1";
export var viewLink = "_or-2";
export var wishlistItem = "_or-0";